
// SVG Icon: backward
export default { id: "terriajs-backward" };
export const id = "terriajs-backward";
export const name = "backward";
